<template>
	<div class="simple-slide">
		<div class="background" :style="{backgroundImage: background ? 'url(' + background + ')' : 'none'}"/>

		<div class="text" v-if="title || description">
			<div class="title" v-if="title">{{ title }}</div>
			<div class="description" v-if="description">{{ description }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'simple-slide',

	props: {
		///
		title: {
			type: String,
			required: false
		},
		///
		description: {
			type: String,
			required: false
		},
		///
		background: {
			type: String,
			required: false
		}
	}
}
</script>

<style lang="stylus" scoped>
.simple-slide
	width 100%
	height 100%

	position relative

.background
	width 100%
	height 100%

	position absolute
	top 0
	left 0
	z-index 1

	background-color primary
	background-position center
	background-size cover

.text
	width 100%

	padding 0.6em 2em
	margin-bottom 57px

	position absolute
	bottom 0
	left 0
	z-index 2

	background-color rgba(dark, 0.2)

	.title
		margin 0.5em 0

		font-size 1.8em
		font-weight bold
	
	.description
		margin 0.5em 0
		font-size 1.2em
</style>